import * as dtos from "@/models/dtos";
import { Buffer } from "buffer";

export class PositionTemplateFolder {
  Folder: dtos.FolderResponse;
  Assets: PositionTemplateAsset[];
  constructor(folder: dtos.FolderResponse) {
    this.Folder = folder;
    this.Assets = folder.assets.map(
      (x: any) => new PositionTemplateAsset(x, this.Folder.containerId)
    ); 
  }
}
export class PositionTemplateAsset {
  data: dtos.PositionTemplateRequest;
  id: number;
  containerId: number;
  folderId: number;
  contentType: string;
  name: string;

  constructor(item: any, containerId: number) {
    const encode = (str: string): string =>
      Buffer.from(str, "utf-8").toString("base64");
    const decode = (str: string): string =>
      Buffer.from(str, "base64").toString("utf-8");

    this.data = JSON.parse(decode(item.data));
    this.id = item.id;
    this.containerId = containerId;
    this.folderId = item.folderId;
    this.contentType = item.contentType;
    this.name = item.name;
  }
}
